import { resolveIAiGeneratedBrowserPublicServiceBaseUrl } from "@airange/shared/platform-urls";

function readEnv(key: string) {
  const value = typeof process !== "undefined" ? process.env?.[key] : undefined;
  return typeof value === "string" ? value.trim().replace(/\/+$/, "") : "";
}

function currentHostname() {
  return typeof window !== "undefined" ? window.location.hostname : undefined;
}

function resolveGeneratedPublicServiceUrl(
  service: "sso-center" | "redblue-admin" | "redblue-portal",
  message: string,
) {
  try {
    return resolveIAiGeneratedBrowserPublicServiceBaseUrl(service, {
      readClientEnv: readEnv,
      hostname: currentHostname(),
    });
  } catch (error) {
    if (error instanceof Error && error.message.startsWith("Cannot resolve ")) {
      throw new Error(message);
    }
    throw error;
  }
}

export const REDBLUE_API_BASE_URL = `${resolveGeneratedPublicServiceUrl(
  "redblue-admin",
  "Redblue admin API base URL fallback is only available in browser",
)}/api`;

export const SSO_API_BASE_URL = resolveGeneratedPublicServiceUrl(
  "sso-center",
  "Redblue admin SSO base URL requires explicit env or a browser host that resolves the sso service",
);

export const SSO_OIDC_SCOPE =
  readEnv("VITE_SSO_OIDC_SCOPE") ||
  readEnv("UMI_APP_SSO_OIDC_SCOPE") ||
  "openid profile email groups offline_access";

export const REDBLUE_OIDC_APP_KEY =
  readEnv("VITE_REDBLUE_OIDC_APP_KEY") ||
  readEnv("UMI_APP_REDBLUE_OIDC_APP_KEY") ||
  "redblue-admin";

export const PORTAL_BASE_URL = resolveGeneratedPublicServiceUrl(
  "redblue-portal",
  "Redblue admin portal base URL requires explicit env or a browser host that resolves the redblue service",
);
